import React from "react";
import PropTypes from "prop-types";
import "./loadingSpinner.css";

/**
 * LoadingSpinner component for displaying loading states
 * @param {string} size - Size of spinner: 'small', 'medium', 'large', 'fullscreen'
 * @param {string} message - Optional loading message to display
 * @param {string} variant - Color variant: 'primary', 'white'
 */
const LoadingSpinner = ({
  size = "medium",
  message = "",
  variant = "primary",
}) => {
  const sizeClass = `loading-spinner-${size}`;
  const variantClass = `loading-spinner-${variant}`;

  if (size === "fullscreen") {
    return (
      <div className="loading-fullscreen">
        <div className="loading-fullscreen-content">
          <div className={`loading-spinner ${variantClass}`}></div>
          {message && <p className="loading-message">{message}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="loading-spinner-container">
      <div className={`loading-spinner ${sizeClass} ${variantClass}`}></div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
};

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large", "fullscreen"]),
  message: PropTypes.string,
  variant: PropTypes.oneOf(["primary", "white"]),
};

export default LoadingSpinner;
